import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Box,
  MenuItem,
  Select,
  useTheme,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Button,
  Alert,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  Checkbox,
  FormGroup,
  TextField,
  Backdrop,
} from "@mui/material";

import { useFormik } from "formik";
import { inject, observer } from "mobx-react";
import {
  Col,
  Input,
  InputNumber,
  Table,
  Tag,
  Tooltip,
  Upload,
  message,
  Space,
} from "antd";
import RichEditor from "../../components/RichEditor/RichEditor";
import { BankOutlined, TeamOutlined } from "@ant-design/icons";
import * as Yup from "yup";
import {
  AiFillBank,
  AiOutlineDelete,
  AiOutlineFolder,
  AiOutlineUpload,
  AiOutlineUser,
} from "react-icons/ai";
import { User } from "iconoir-react";
import {
  ASSIGNEE_TYPE,
  PROPOSAL_STATUS,
  SHIFTS,
  TYPE_STATUS,
  MODES,
  DATE_FORMAT_SLASH,
} from "../../utils/constants";
import SelectPeoplePopup from "../../components/SelectPeoplePopup/SelectPeoplePopup";
import { AvatarHasName } from "../../components/common/Avatar";
import "../../components/RichEditor/RichEditor.scss";
import "./CreateModal.scss";
import { MyUploadAdapter } from "./../../components/RichEditor/MyUploadAdapter";
import { useNavigate } from "react-router-dom";
import PopupRenameFile from "../../components/PopupRenameFile/PopupRenameFile";
import utils from "../../utils";
import moment from "moment";
import { Inputs } from "../../components/input/inputStyled";
import { StatusTag } from "../../components/common/StatusTag";
import { SelectList } from "../InternalDocumentIncoming/InternalDocumentIncomingDocCreatePageStyled";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import "dayjs/locale/vi"; // Import ngôn ngữ tiếng Việt cho dayjs
import CircularProgress from "@mui/material/CircularProgress";
import { toJS } from "mobx";
import Message from "../../components/common/Message";
import { ISO_DATE_FORMAT } from "../../constants";
dayjs.locale("vi"); // Đặt ngôn ngữ mặc định cho dayjs

const toolbar = [
  "insertTable",
  "Alignment",
  "Autoformat",
  "AutoLink",
  "BlockQuote",
  "Bold",
  "Essentials",
  "FontBackgroundColor",
  "FontColor",
  "FontFamily",
  "FontSize",
  "Heading",
  "Image",
  "ImageInsert",
  "ImageResize",
  "ImageStyle",
  "ImageToolbar",
  "ImageUpload",
  "Indent",
  "IndentBlock",
  "Italic",
  "Link",
  "List",
  "ListStyle",
  "MediaEmbed",
  "MediaEmbedToolbar",
  "Mention",
  "Paragraph",
  "PasteFromOffice",
  "Strikethrough",
  "Table",
  "TableCellProperties",
  "TableProperties",
  "TableToolbar",
  "TextTransformation",
  "TodoList",
  "Underline",
  "WordCount",
];
// const currentStep = 0
const CreateModal = (props) => {
  let {
    approvalTemplates,
    params,
    setFilter,
    open,
    code,
    proposalTypes,
    handleClose,
    selectPeopleStore,
    fileStore,
    proposalStore,
    authenticationStore,
    showSubmissionMenu,
    selectUserStore,
    contentTemplateStore,
  } = props;
  // const { content } = contentTemplateStore;
  // let { proposalApproveConfig, items, content, formProposalType } =
  //   proposalStore;
  let { proposalApproveConfig, items } = proposalStore;
  const EDITOR_REF = useRef();
  const [editorState, setEditorState] = useState(null);
  const [proposalId, setProposalId] = useState("");
  const [keyForm, setKeyForm] = useState("");
  const theme = useTheme();
  const [approvalLevels, setApprovalLevels] = useState([]);
  const [isVisibleSelectUserPopup, setIsVisibleSelectUserPopup] =
    useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [userNextStep, setUserNextStep] = useState();
  const [warningMessage, setWarningMessage] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [reasonForLeaving, setReasonForLeaving] = useState("");
  const [overtime, setOvertime] = useState("");
  const [proposalTypeById, setProposalTypeById] = useState(null);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [typeOfLeave, setTypeOfLeave] = useState(null);
  const [messageTypeOfLeave, setMessageTypeOfLeave] = useState(null);
  const [messageOverTime, setMessageOverTime] = useState(null);
  const [editorContent, setEditorContent] = useState("");

  useEffect(() => {
    const loadData = async () => {
      try {
        await contentTemplateStore.load();
        const response = await contentTemplateStore.getDetails(
          proposalTypeById?.contentKey
        );

        const content = response.data.content;

        // Đảm bảo rằng content không phải là undefined hoặc null trước khi thiết lập state
        if (content !== undefined && content !== null) {
          setEditorContent(content);
        } else {
          setEditorContent("");
        }

        // Các hoạt động khác
        setReasonForLeaving("");
        setOvertime("");
      } catch (error) {
        // Xử lý lỗi
      }
    };

    loadData();

    return () => {
      contentTemplateStore.clear();
    };
  }, [proposalTypeById]);
  //Lấy details của các cấp duyệt
  const getApprovalLevelTemplate = async (code) => {
    try {
      selectPeopleStore.clearSelectUserData();
      const response = await proposalStore.getApprovalLevelTemplateByATCode(
        code
      );
      const approvalLevelsChange = response.data.map(
        (approvalLevel, index) => ({
          status: index === 0 ? "CREATED" : "WAITING",
          allow_edit: approvalLevel.allow_edit,
          code: approvalLevel.code,
          isDeleted: approvalLevel.isDeleted,
          level: approvalLevel.level,
          name: approvalLevel.name,
          username: approvalLevel.username,
        })
      );
      if (approvalLevelsChange && approvalLevelsChange.length > 0) {
        const approvalLevelConvert = approvalLevelsChange.map((item) => {
          return {
            ...item,
            user: getInfoUser(item.username, originDepartmentWithUserList),
          };
        });
        const levelAllowEditList = approvalLevelConvert.filter(
          (item) => item.allow_edit
        );
        let create = null;
        let combiner = null;
        let handler = null;
        let leader = null;
        let unitLeader = null;
        levelAllowEditList.forEach((item, index) => {
          if (!item.username) return;
          const user = getInfoUser(item.username, originDepartmentWithUserList);
          if (index === 0) {
            create = user;
          }
          if (index === 1) {
            combiner = user;
          }
          if (index === 2) {
            handler = user;
          }
          if (index === 3) {
            leader = user;
          }
          if (index === 4) {
            unitLeader = user;
          }
        });
        selectPeopleStore.setSelectUserData({
          ...selectUserData,
          [ASSIGNEE_TYPE.CREATE]: create
            ? [
                {
                  assignee_type: ASSIGNEE_TYPE.USER,
                  full_name: create.full_name,
                  id: create.username,
                  image_id: create.image_id,
                  permission: ASSIGNEE_TYPE.CREATE,
                },
              ]
            : [],
          [ASSIGNEE_TYPE.COMBINER]: combiner
            ? [
                {
                  assignee_type: ASSIGNEE_TYPE.USER,
                  full_name: combiner.full_name,
                  id: combiner.username,
                  image_id: combiner.image_id,
                  permission: ASSIGNEE_TYPE.COMBINER,
                },
              ]
            : [],
          [ASSIGNEE_TYPE.HANDLER]: handler
            ? [
                {
                  assignee_type: ASSIGNEE_TYPE.USER,
                  full_name: handler.full_name,
                  id: handler.username,
                  image_id: handler.image_id,
                  permission: ASSIGNEE_TYPE.HANDLER,
                },
              ]
            : [],
          [ASSIGNEE_TYPE.LEADER]: leader
            ? [
                {
                  assignee_type: ASSIGNEE_TYPE.USER,
                  full_name: leader.full_name,
                  id: leader.username,
                  image_id: leader.image_id,
                  permission: ASSIGNEE_TYPE.LEADER,
                },
              ]
            : [],
          [ASSIGNEE_TYPE.UNIT_LEADER]: unitLeader
            ? [
                {
                  assignee_type: ASSIGNEE_TYPE.USER,
                  full_name: unitLeader.full_name,
                  id: unitLeader.username,
                  image_id: unitLeader.image_id,
                  permission: ASSIGNEE_TYPE.UNIT_LEADER,
                },
              ]
            : [],
        });
        setApprovalLevels(approvalLevelConvert);
      }
    } catch (err) {
      console.log(err);
      message.error(err?.vi || "Đã có lỗi xảy ra!");
    }
  };

  // Nếu có người theo dõi thì SelectPeoplePopup của người theo dõi sẽ được chọn nhiều người
  const [checkFollower, setCheckFollower] = useState(true);

  // List step
  let approvalLevelList = approvalLevels || [];
  // Lấy curentUser để gán vào list step
  useEffect(() => {
    const approvalLevelList = [
      ...proposalStore.proposalApproveConfig.approvalLevels,
    ];
    if (approvalLevelList.length === 0) {
      setApprovalLevels([]);
      return;
    }
    approvalLevelList[0].username = authenticationStore.currentUser?.username;
    setApprovalLevels(approvalLevelList);
  }, [proposalStore.proposalApproveConfig, authenticationStore.currentUser]);

  useEffect(() => {
    if (editorState) {
      const editor = editorState;
      editor.plugins.get("FileRepository").createUploadAdapter = function (
        loader
      ) {
        return new MyUploadAdapter(loader);
      };

      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );

      editor.editing.view.change((writer) => {
        writer.setStyle(
          "height",
          "200px",
          editor.editing.view.document.getRoot()
        );
      });
    }
  }, [editorState]);

  const [fileExt, setFileExt] = useState(undefined);
  const [fileTargetRename, setFileTargetRename] = useState(null);
  const [fileFromDocumentList, setFileFromDocumentList] = useState([]);
  const [handlerList, setHandlerList] = useState([]);
  const [followerList, setFollowerList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [data, setData] = useState("");
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] =
    useState(false);
  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ["rename"],
      value: "",
    },
  ]);
  const [isRenameFileUpdate, setIsRenameFileUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    originDepartmentWithUserList,
  } = selectPeopleStore;

  const getInfoUser = (username, departmentWithUserList) => {
    const user = {
      full_name: username,
      image_id: null,
      username: username,
    };
    departmentWithUserList.forEach((department) => {
      const userTarget = department.users.find(
        (user) => user.user_name === username
      );
      if (userTarget) {
        user.full_name = userTarget.name_uppercase || username;
        user.image_id = userTarget.image_id;
      }
    });
    return user;
  };

  useEffect(() => {
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ]);
  }, [selectUserData, selectDepartmentData, selectGroupData]);

  const updateAttachments = useCallback(async () => {
    const uploadFileList = fileList.map((file) => file.originFileObj);
    const batchUploadArr = [];
    uploadFileList.forEach((file) => {
      const formData = new FormData();
      formData.append("file", file);
      batchUploadArr.push(fileStore.uploadFile(formData));
    });
    const response = await Promise.all(batchUploadArr);
    const res = response
      .map((response) => response.data.file_id)
      .concat(fileFromDocumentList.map((file) => file.file_id));
    formik.setFieldValue("file_ids", res);
  }, [fileList, fileFromDocumentList]);

  useEffect(() => {
    updateAttachments();
    formik.setFieldValue("parent_id", code);
  }, [updateAttachments]);

  useEffect(() => {
    formik.setFieldValue("reason", editorContent);
  }, [editorContent]);

  useEffect(() => {
    let listApprovalLevel = approvalLevels.map((item) => ({
      level: item.level,
      name: item.name,
      username: item.username,
      allow_edit: item.allow_edit,
      status:
        item.level === currentStep + 1 ? PROPOSAL_STATUS.PENDING : item.status,
    }));
    formik.setFieldValue("approval_levels", listApprovalLevel);
  }, [approvalLevels]);

  useEffect(() => {
    let listFollower = followerList.map((el) => el.id);
    formik.setFieldValue("followers", listFollower);
  }, [followerList]);

  useEffect(() => {
    formik.setFieldValue("reason_for_leaving", reasonForLeaving);
  }, [reasonForLeaving]);

  useEffect(() => {
    formik.setFieldValue("type_of_leave", typeOfLeave);
  }, [typeOfLeave]);

  useEffect(() => {
    if (warningMessage) {
      setShowWarning(true);

      // Đặt một khoảng thời gian để thông báo tự động biến mất sau 1-2 giây
      const timeout = setTimeout(() => {
        setWarningMessage("");
        setShowWarning(false);
      }, 2000); // 2000 milliseconds = 2 giây

      return () => clearTimeout(timeout); // Xóa timeout khi component unmount
    }
  }, [warningMessage]);

  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      title: "",
      file_ids: "",
      followers: "",
      proposal_type: "BUSINESS_TRIP",
      reason: "",
      approval_levels: "",
      from_date: "",
      to_date: "",
      reason_for_leaving: "",
      type_of_leave: "",
      overtime: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().trim().required("Vui lòng nhập tiêu đề."),
      from_date: Yup.string().required("Vui lòng chọn ngày bắt đầu."),
      to_date: Yup.string().required("Vui lòng chọn ngày kết thúc."),
    }),
    onSubmit: async (values) => {
      let hasInvalidItem = false;
      if (proposalTypeById.id === "LEAVE") {
        if (values.type_of_leave === null) {
          setMessageTypeOfLeave("Vui lòng chọn loại nghỉ phép.");
          hasInvalidItem = true;
        } else {
          setMessageTypeOfLeave(null);
          hasInvalidItem = false;
        }
      }
      if (
        proposalTypeById.id === "OVERTIME_NORMAL" ||
        proposalTypeById.id === "OVERTIME_DAYOFF" ||
        proposalTypeById.id === "OVERTIME_HOLIDAY"
      ) {
        const overtimeValue = values.overtime;

        // Check if overtimeValue is null or empty
        if (overtimeValue === null || overtimeValue.trim() === "") {
          setMessageOverTime(null);
          hasInvalidItem = false;
        } else if (!/^(-)?\d+(\.\d+)?$/.test(overtimeValue)) {
          setMessageOverTime("Vui lòng nhập số.");
          hasInvalidItem = true;
        } else {
          const numericValue = parseFloat(overtimeValue);

          if (numericValue <= 0) {
            setMessageOverTime("Vui lòng nhập số lớn hơn 0.");
            hasInvalidItem = true;
          } else if (numericValue > 12) {
            setMessageOverTime("Vui lòng nhập số nhỏ hơn 12.");
            hasInvalidItem = true;
          } else {
            setMessageOverTime(null);
            hasInvalidItem = false;
          }
        }
      }
      approvalLevels.forEach((item) => {
        if (!item?.username) {
          setWarningMessage(`Hãy chọn đủ các cấp duyệt!`);
          hasInvalidItem = true;
        }
      });
      // Nếu hasInvalidItem = true thì dừng chạy
      if (hasInvalidItem) {
        return;
      }
      // Nếu isSubmitting = true thì dừng chạy
      if (isSubmitting) {
        return;
      }
      setIsSubmitting(true);

      let proposal = {
        ...values,
        reason: EDITOR_REF.current.editor.getData(),
        proposalTimeList,
        proposal_type: proposalTypeById.id
          ? proposalTypeById.id
          : "BUSINESS_TRIP",
      };

      try {
        setIsLoading(true);
        proposalStore.createOther(proposal);
        await proposalStore.getProposals(params);
        message.success("Tạo mới thành công!");
      } catch (err) {
        console.log(err);
      } finally {
        setIsSubmitting(false);
        setIsLoading(false);
        close();
      }
    },
  });

  const close = () => {
    formik.resetForm();
    setFilter({
      page: 0,
      size: 10,
      // keyword: null,
      // proposalStatus: null,
      // type: null,
      // proposal_permission: null,
    });
    setData("");
    selectPeopleStore.clearSelected();
    setFileList([]);
    setHandlerList([]);
    setFollowerList([]);
    setProposalId([]);
    setApprovalLevels([]);
    setProposalTypeById("BUSINESS_TRIP");
    setIsCheckboxChecked(false);
    handleClose();

    return navigate("/proposal");
  };

  const handleOpenPopupRenameFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ["rename"],
        value: utils.removeExtensionFile(file.name),
      },
    ]);
    setFileExt("." + utils.getExtensionFile(file.name));
    setFileTargetRename({
      ...file,
      index: index,
    });
    setIsModalVisibleRenameFile(true);
  };

  const handleFileChange = useCallback(async (info) => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex((file) => file.name === elem.name) === index
    );
    setFileList(filteredFileList);
  }, []);
  const handleRemoveFileFromDocumentList = (file_id) => {
    const newFileList = fileFromDocumentList.filter(
      (file) => file.file_id !== file_id
    );
    setFileFromDocumentList(newFileList);
  };
  const handleRemoveFileFromUploadList = (fileUID) => {
    const newFileList = fileList.filter((file) => file.uid !== fileUID);
    setFileList(newFileList);
  };
  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });
  };
  const submitRenameFile = async (value) => {
    const index = fileTargetRename?.index;
    // đổi tên file nhận từ thiết bị (file chưa ký)
    if (fileTargetRename.originFileObj) {
      const newFileList = [...fileList];
      newFileList[index].name = value.rename + fileExt;
      newFileList[index].originFileObj = renameFile(
        newFileList[index].originFileObj,
        newFileList[index].name
      );
      setFileList(newFileList);
      setIsModalVisibleRenameFile(false);
      // message.success('Đổi tên file thành công')
    }
    // đổi tên file nhận từ thiết bị (file đã ký)
    if (!fileTargetRename.originFileObj) {
      await fileStore.handleRenameFile(
        fileTargetRename.id,
        value.rename + fileExt
      );
      setIsModalVisibleRenameFile(false);
      const newFileList = [...fileList];
      newFileList[index].name = value.rename + fileExt;
      setFileList(newFileList);
      message.success("Đổi tên file thành công");
    }
  };

  const ASSIGNEE_TYPE_CONFIG = [
    ASSIGNEE_TYPE.CREATE,
    ASSIGNEE_TYPE.COMBINER,
    ASSIGNEE_TYPE.HANDLER,
    ASSIGNEE_TYPE.LEADER,
    ASSIGNEE_TYPE.UNIT_LEADER,
  ];

  const [initialProposalTypeById, setInitialProposalTypeById] = useState(null);
  useEffect(() => {
    const defaultProposalType = proposalTypes.find(
      (item) => item.id === "BUSINESS_TRIP"
    );
    setProposalTypeById(defaultProposalType);
    setInitialProposalTypeById(defaultProposalType);
  }, [proposalTypes]);
  /** Render thông tin khi thay đổi form phiếu trình  */
  const [newContent, setNewContent] = useState();
  const handleChangeFormType = (event) => {
    const proposalType = proposalTypes.find(
      (item) => item.id === event.target.value
    );
    setKeyForm(event.target.value);
    setProposalTypeById(proposalType);
    selectUserStore.clearSelectData();
    setNewContent(editorContent);
    // console.log("proposalType", proposalType);
  };
  useEffect(() => {
    if (checkFollower === true) {
      const approvalLevelsUpdate = approvalLevels.map((item) => {
        if (!item.allow_edit) {
          return item;
        }
        const assignTypeIndex = approvalLevels
          .filter((el) => el.allow_edit)
          .findIndex((el) => el.level === item.level);
        const getUser = (index) => {
          if (![0, 1, 2, 3, 4].includes(index)) {
            return {};
          }
          return selectUserData[ASSIGNEE_TYPE_CONFIG[index]].length > 0
            ? selectUserData[ASSIGNEE_TYPE_CONFIG[index]][0]
            : {};
        };
        return {
          ...item,
          username: getUser(assignTypeIndex).id,
          user: {
            full_name: getUser(assignTypeIndex).full_name,
            image_id: getUser(assignTypeIndex).image_id,
            username: getUser(assignTypeIndex).id,
          },
        };
      });
      setApprovalLevels(approvalLevelsUpdate);
    }
  }, [checkFollower, selectUserData]);

  const handleChangeStyle = (event) => {
    setProposalId(event.target.value);
    getApprovalLevelTemplate(event.target.value);
  };

  // render list biểu mẫu trong phần nội dung
  const listForm = items.map((item, index) => (
    <MenuItem key={index} value={item.key}>
      {item.label}
    </MenuItem>
  ));

  // lấy list biểu mẫu
  useEffect(() => {
    proposalStore.load();

    return () => {
      proposalStore.clear();
    };
  }, []);

  const handleChangeForm = (event) => {
    proposalStore.getDetails(event.target.value);
    setKeyForm(event.target.value);
  };

  const handleOpenSelectUser = (level) => {
    let userType = null;
    if (level === ASSIGNEE_TYPE.FOLLOWER) {
      userType = level;
      setCheckFollower(false);
    } else {
      setCheckFollower(true);
    }
    const levelAllowEditList = approvalLevels?.filter(
      (item) => item.allow_edit
    );
    const indexLevelAllowEdit = levelAllowEditList.findIndex(
      (item) => item.level === level
    );
    if (indexLevelAllowEdit !== -1) {
      userType = ASSIGNEE_TYPE_CONFIG[indexLevelAllowEdit];
    }
    if (userType) {
      selectPeopleStore.setAssigneePopupType(userType);
      setIsVisibleSelectUserPopup(true);
    } else {
      return message.warning("Không rõ chọn người loại nào!");
    }
  };

  const handleSubmitSelectUser = useCallback(() => {
    setIsVisibleSelectUserPopup(false);
  }, []);

  // sự kiện chọn Lý do
  const handleChangeReasonForLeaving = (event) => {
    formik.handleChange({
      target: {
        name: "reason_for_leaving",
        value: event.target.value,
      },
    });
  };

  // sự kiện chọn Loại nghỉ phép
  const handleChangeTypeForLeaving = (event) => {
    setTypeOfLeave(event.target.value);
  };

  // sự kiện active input Thêm giờ làm việc
  const handleCheckboxChange = (event) => {
    setIsCheckboxChecked(event.target.checked);
  };
  const [messages, setMessage] = useState("");
  const [openMessage, setOpenMessage] = useState(false);
  const [severity, setSeverity] = useState("");
  const createMessage = (messages, openMessage, severity) => {
    setMessage(messages);
    setOpenMessage(openMessage);
    setSeverity(severity);
  };
  const handleChangeStartDate = (startAt) => {
    if (formik.values.to_date !== "") {
      if (moment(formik.values.to_date.$d).isSameOrAfter(moment(startAt.$d))) {
        formik.handleChange({
          target: {
            name: "from_date",
            value: startAt,
          },
        });
      } else {
        formik.handleChange({
          target: {
            name: "from_date",
            value: null,
          },
        });
        createMessage(
          "thời gian bắt đàu không thể muộn hơn thời gian kết thúc, xin vui lòng chọn lại !!!",
          true,
          "error"
        );
      }
    } else {
      formik.handleChange({
        target: {
          name: "from_date",
          value: startAt,
        },
      });
    }
  };
  const onChangeEndAt = (endAt) => {
    if (moment(endAt.$d).isSameOrAfter(moment(formik.values.from_date.$d))) {
      formik.handleChange({
        target: {
          name: "to_date",
          value: endAt,
        },
      });
    } else {
      formik.handleChange({
        target: {
          name: "to_date",
          value: null,
        },
      });
      createMessage(
        "thời gian kết thúc không thể sớm hơn thời gian bắt đầu, xin vui lòng chọn lại !!!",
        true,
        "error"
      );
    }
  };

  const [selectedDates, setSelectedDates] = useState([]);
  const [proposalTimeList, setProposalTimeList] = useState([]);

  const handleShiftChange = (value, recordKey) => {
    const updatedWorkDays = proposalTimeList.map(day =>
      day.key === recordKey ? { ...day, shift: value } : day
    );
    setProposalTimeList(updatedWorkDays);
  };

  const handleModeChange = (value, recordKey) => {
    let modeTypeValue = 0;

    if (value === MODES.WOMEN.key) {
      modeTypeValue = 0.5;
    } else if (value === MODES.CHILD_CARE.key) {
      modeTypeValue = 1;
    }

    const updatedWorkDays = proposalTimeList.map(day =>
      day.key === recordKey
        ? { ...day, mode: value, mode_type: modeTypeValue }
        : day
    );
    setProposalTimeList(updatedWorkDays);
  };

  const handleModeTypeChange = (value, recordKey) => {
    const updatedWorkDays = proposalTimeList.map(day =>
      day.key === recordKey ? { ...day, mode_type: value } : day
    );
    setProposalTimeList(updatedWorkDays);
  };

  const handleNoteChange = (value, recordKey) => {
    const updatedWorkDays = proposalTimeList.map(day =>
      day.key === recordKey ? { ...day, note: value } : day
    );
    setProposalTimeList(updatedWorkDays);
  };

  const handleDateChange = (date, index) => {
    const newDateRange = [...selectedDates];
    newDateRange[index] = dayjs(date).startOf("day").format(DATE_FORMAT_SLASH);
    setSelectedDates(newDateRange);
  };

  function getRange(startDate, endDate) {
    console.log("object", startDate, endDate);
    let fromDate = moment(startDate, DATE_FORMAT_SLASH);
    let toDate = moment(endDate, DATE_FORMAT_SLASH);
    let diff = toDate.diff(fromDate, "days");
    let range = [];

    for (let i = 0; i <= diff; i++) {
      let currentDay = moment(startDate, DATE_FORMAT_SLASH).add(i, "days");
      if (proposalTypeById.id === "OVERTIME_NORMAL") {
        range.push(currentDay);
      } else {
        if (currentDay.day() !== 6 && currentDay.day() !== 0) {
          range.push(currentDay);
        }
      }
    }

    return range;
  }

  const generateWorkDays = () => {
    const workDays = [];
    const dateRange = getRange(selectedDates[0], selectedDates[1]);
    if (dateRange?.length > 0) {
      if (proposalTypeById?.id === "LEAVE_ABNORMAL") {
        dateRange.forEach((date, index) => {
          workDays.push({
            key: index.toString(),
            date: date,
            shift: "morning",
            mode: "normal",
            mode_type: 0,
            note: null,
          });
        });
      } else {
        dateRange.forEach((date, index) => {
          workDays.push({
            key: index.toString(),
            date: date,
            shift: "allDay",
            mode: "normal",
            note: null,
          });
        });
      }
      setProposalTimeList(workDays);
    } else {
      setProposalTimeList([]);
    }
  };

  useEffect(() => {
    selectedDates?.length > 0 && generateWorkDays();
  }, [selectedDates]);

  const columns = [
    {
      title: "Ngày làm việc",
      dataIndex: "date",
      key: "date",
      render: text => <span>{moment(text).format("DD/MM/YYYY")}</span>,
      // fixed: 'left',
    },
    {
      title: "Buổi làm việc",
      dataIndex: "shift",
      key: "shift",
      render: (text, record) => (
        <Select
          style={{
            width: "120px",
          }}
          defaultValue={text}
          value={text}
          onChange={value => handleShiftChange(value.target.value, record.key)}
          size="small"
        >
          <MenuItem value={SHIFTS.ALL_DAY.key}>{SHIFTS.ALL_DAY.value}</MenuItem>
          <MenuItem value={SHIFTS.MORNING.key}>{SHIFTS.MORNING.value}</MenuItem>
          <MenuItem value={SHIFTS.AFTERNOON.key}>
            {SHIFTS.AFTERNOON.value}
          </MenuItem>
          <MenuItem value={SHIFTS.EMPTY.key}>{SHIFTS.EMPTY.value}</MenuItem>
        </Select>
      ),
    },
    ...(proposalTypeById?.id !== "BUSINESS_TRIP" &&
    proposalTypeById?.id !== "OVERTIME_NORMAL"
      ? [
          {
            title: "Loại nghỉ phép",
            dataIndex: "mode",
            key: "mode",
            render: (text, record) => (
              <Select
                style={{
                  width: "120px",
                }}
                defaultValue={text}
                onChange={value => handleModeChange(value, record.key)}
                size="small"
              >
                <MenuItem value={MODES.NORMAL.key}>
                  {MODES.NORMAL.value}
                </MenuItem>
                <MenuItem value={MODES.SPECIAL.key}>
                  {MODES.SPECIAL.value}
                </MenuItem>
              </Select>
            ),
          },
        ]
      : []),
    ...(proposalTypeById?.id === "OVERTIME_NORMAL"
      ? [
          {
            title: "Giờ",
            dataIndex: "mode_type",
            key: "mode_type",
            width: "150px",
            render: (text, record) => {
              return (
                <InputNumber
                  style={{ width: "90px" }}
                  defaultValue={0}
                  min={0}
                  // max={8}
                  onChange={value => handleModeTypeChange(value, record.key)}
                />
              );
            },
          },
        ]
      : []),
    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "note",
      render: (text, record) => (
        <Input
          value={text}
          onChange={e => handleNoteChange(e.target.value, record.key)}
          placeholder="Nhập ghi chú"
        />
      ),
    },
  ];

  const leaveAbnormalColumns = [
    {
      title: "Ngày làm việc",
      dataIndex: "date",
      key: "date",
      render: text => <span>{moment(text).format("DD/MM/YYYY")}</span>,
      // fixed: 'left',
    },
    {
      title: "Buổi làm việc",
      dataIndex: "shift",
      key: "shift",
      render: (text, record) => (
        <Select
          style={{
            width: "120px",
          }}
          defaultValue={text}
          value={text}
          onChange={value => handleShiftChange(value.target.value, record.key)}
          size="small"
        >
          <MenuItem value={SHIFTS.MORNING.key}>{SHIFTS.MORNING.value}</MenuItem>
          <MenuItem value={SHIFTS.AFTERNOON.key}>
            {SHIFTS.AFTERNOON.value}
          </MenuItem>
          <MenuItem value={SHIFTS.EMPTY.key}>{SHIFTS.EMPTY.value}</MenuItem>
        </Select>
      ),
    },
    {
      title: "Loại nghỉ phép",
      dataIndex: "mode",
      key: "mode",
      render: (text, record) => (
        <Select
          style={{
            width: "160px",
          }}
          defaultValue={text}
          onChange={value => handleModeChange(value.target.value, record.key)}
          size="small"
        >
          <MenuItem value={MODES.NORMAL.key}>{MODES.NORMAL.value}</MenuItem>
          <MenuItem value={MODES.WOMEN.key}>{MODES.WOMEN.value}</MenuItem>
          <MenuItem value={MODES.CHILD_CARE.key}>
            {MODES.CHILD_CARE.value}
          </MenuItem>
          <MenuItem value={MODES.WORK_REASON.key}>
            {MODES.WORK_REASON.value}
          </MenuItem>
          <MenuItem value={MODES.BY_REGIME.key}>
            {MODES.BY_REGIME.value}
          </MenuItem>
        </Select>
      ),
    },
    {
      title: "Thời gian (giờ)",
      dataIndex: "mode_type",
      key: "mode_type",
      width: "150px",
      render: (text, record) => {
        switch (record.mode) {
          case MODES.NORMAL.key:
          case MODES.WORK_REASON.key:
          case MODES.BY_REGIME.key:
            return (
              <InputNumber
                style={{ width: "90px" }}
                defaultValue={0}
                min={0}
                max={8}
                onChange={value => handleModeTypeChange(value, record.key)}
              />
            );
          case MODES.WOMEN.key:
            return <span>0.5</span>;
          case MODES.CHILD_CARE.key:
            return <span>1</span>;
          default:
            return null;
        }
      },
    },
    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "note",
      width: "250px",
      render: (text, record) => (
        <Input
          value={text}
          onChange={e => handleNoteChange(e.target.value, record.key)}
          placeholder="Nhập ghi chú"
        />
      ),
    },
  ];
  
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll={"paper"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100vw",
            maxWidth: "100vw", // Set your width here
            mx: 0,
            zIndex: 10,
          },
        },
      }}
    >
      {/*  Tạo loading khi tạo mới*/}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {warningMessage && (
        <div className="fixed z-50">
          <Alert severity="warning">{warningMessage}</Alert>
        </div>
      )}
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#ffffff] "
          sx={{
            fontWeight: 700,
            backgroundColor: "#2C65AC",
          }}
        >
          <span className="font-bold">Tạo mới</span>
        </DialogTitle>
        <DialogContent>
          <div className="mt-4 font-semibold">Cấp duyệt :</div>
          <div>
            <Select
              displayEmpty
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={proposalId}
              onChange={handleChangeStyle}
              fullWidth
              style={{ height: "40px" }}
            >
              <MenuItem value="" disabled>
                Chọn loại cấp duyệt
              </MenuItem>
              {approvalTemplates.map((item) => (
                <MenuItem value={item.code} key={item.code}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </div>
          {approvalLevels.length > 0 ? (
            <>
              <Box>
                <InputLabel style={{ marginTop: "20px", color: "#23374D" }}>
                  <span className="text-red-500">*</span> Tiêu đề:
                </InputLabel>
                <Inputs
                  name="title"
                  value={formik.values.title}
                  placeholder={"Nhập tiêu đề..."}
                  onChange={formik.handleChange}
                />
                {formik.errors.title && formik.touched.title && (
                  <p className="text-red-500">{formik.errors.title}</p>
                )}
              </Box>

              <Box className="mb-5">
                <InputLabel style={{ marginTop: "20px", color: "#23374D" }}>
                  Loại:
                </InputLabel>
                <Select
                  native
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ width: "100%", marginTop: 5 }}
                  placeholder="Chọn loại"
                  onChange={handleChangeFormType}
                  value={proposalTypeById?.id}
                  // value={keyForm}
                >
                  {showSubmissionMenu}
                </Select>
                <InputLabel className="mt-5 mb-1 text-[#23374D]">
                  Nội dung:
                </InputLabel>
                <RichEditor
                  EDITOR_REF={EDITOR_REF}
                  placeholder={"Nhập nội dung..."}
                  setData={setData}
                  editorContent={editorContent && editorContent}
                />
              </Box>

              {/* {proposalTypeById.id === "LEAVE_ABNORMAL" && (
                <Box xs={24} lg={24}>
                  <label>Lý do:</label>
                  <br />
                  <FormControl>
                    <RadioGroup
                      name="reason_for_leaving"
                      onChange={handleChangeReasonForLeaving}
                      value={formik.values.reason_for_leaving}
                    >
                      <FormControlLabel
                        value={"Theo chế độ"}
                        control={<Radio />}
                        label="Theo chế độ"
                      />
                      <FormControlLabel
                        value={"Lý do cá nhân"}
                        control={<Radio />}
                        label="Lý do cá nhân"
                      />
                      <FormControlLabel
                        value={"Lý do công việc"}
                        control={<Radio />}
                        label="Lý do công việc"
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              )} */}

              {/* {proposalTypeById.id === "LEAVE" && (
                <Box xs={24} lg={24}>
                  <FormControl>
                    <FormLabel
                      id="radio-buttons-group-label"
                      className="text-black"
                    >
                      <span className="text-red-500">*</span> Loại nghỉ phép:
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="type_of_leave"
                      onChange={handleChangeTypeForLeaving}
                    >
                      <FormControlLabel
                        value="Nghỉ phép 1/2 ngày công"
                        control={<Radio />}
                        label="Nghỉ phép 1/2 ngày công"
                      />
                      <FormControlLabel
                        value="Nghỉ phép theo chế độ"
                        control={<Radio />}
                        label="Nghỉ phép theo chế độ"
                      />
                    </RadioGroup>
                  </FormControl>
                  {messageTypeOfLeave ? (
                    <div className="text-red-500">{messageTypeOfLeave}</div>
                  ) : null}
                </Box>
              )} */}

              <Box xs={24} sm={12} md={10} className="w-2/3">
                <p className="mt-5 mb-1">
                  <span className="text-red-500">*</span> Ngày bắt đầu:
                </p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <MobileDatePicker
                    name="from_date"
                    value={formik.values.from_date}
                    onChange={(startAt) => {
                      handleChangeStartDate(startAt);
                      handleDateChange(startAt, 0);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputLabelProps={{ shrink: false }}
                        placeholder="Chọn ngày bắt đầu"
                        className="border-black w-full"
                      />
                    )}
                  />
                  {formik.errors.from_date && formik.touched.from_date && (
                    <p className="text-red-500">{formik.errors.from_date}</p>
                  )}
                </LocalizationProvider>
                <div className="mt-1 mb-5">
                  <p className="mt-2 mb-1">
                    <span className="text-red-500">*</span> Ngày kết thúc:
                  </p>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                      name="to_date"
                      value={formik.values.to_date}
                      onChange={(endAt) => {
                        onChangeEndAt(endAt);
                        handleDateChange(endAt, 1);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputLabelProps={{ shrink: false }}
                          placeholder="Chọn ngày kết thúc"
                          className="border-black w-full"
                        />
                      )}
                    />
                    {formik.errors.to_date && formik.touched.to_date && (
                      <p className="text-red-500">{formik.errors.to_date}</p>
                    )}
                  </LocalizationProvider>
                </div>
              </Box>

              <Box>
                {(proposalTypeById.id === "LEAVE" ||
                  proposalTypeById.id === "BUSINESS_TRIP" ||
                  proposalTypeById.id === "RETIMEKEEPING" ||
                  proposalTypeById.id === "OVERTIME_NORMAL" ||
                  proposalTypeById.id === "LEAVE_ABNORMAL") &&
                  proposalTimeList?.length > 0 && (
                    <Col xs={24} style={{ marginBottom: "25px" }}>
                      <Table
                        pagination={false}
                        columns={
                          proposalTypeById.id === "LEAVE_ABNORMAL"
                            ? leaveAbnormalColumns
                            : columns
                        }
                        dataSource={proposalTimeList}
                        scroll={{
                          x: 800,
                        }}
                      />
                    </Col>
                  )}
              </Box>
{/* 
              <Box className="w-2/3">
                {(proposalTypeById.id === "OVERTIME_NORMAL" ||
                  proposalTypeById.id === "OVERTIME_DAYOFF" ||
                  proposalTypeById.id === "OVERTIME_HOLIDAY") && (
                  <>
                    <Box>
                      <label>Thêm số giờ làm việc:</label>
                      <Checkbox
                        style={{ marginLeft: "5px", paddingTop: "5px" }}
                        checked={isCheckboxChecked}
                        onChange={handleCheckboxChange}
                      ></Checkbox>
                      <br />
                      <TextField
                        className="w-full"
                        hiddenLabel
                        id="filled-hidden-label-normal"
                        name="overtime"
                        value={formik.values.overtime}
                        onChange={formik.handleChange}
                        placeholder="Nhập số giờ dương <= 12"
                        disabled={!isCheckboxChecked}
                      />
                      {messageOverTime ? (
                        <div className="text-red-500">{messageOverTime}</div>
                      ) : null}
                    </Box>
                  </>
                )}
              </Box> */}

              <Box
                sx={{
                  margin: "10px 0",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Upload
                  valuePropName={"fileList"}
                  fileList={fileList}
                  multiple={true}
                  onChange={handleFileChange}
                  beforeUpload={() => false}
                  showUploadList={false}
                >
                  <Button variant="contained">
                    <AiOutlineUpload className="mr-2 -mt-1" />
                    Chọn tài liệu đính kèm
                  </Button>
                </Upload>
              </Box>
              {fileFromDocumentList.length !== 0 && (
                <ul
                  style={{
                    margin: "10px 0 0",
                    paddingLeft: "0 !important",
                    height: " auto !important",
                    overflow: "hidden !important",
                  }}
                >
                  {fileFromDocumentList.map((file) => (
                    <li
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "8px",
                        transition: "all ease 0.3s",
                        padding: "3px 0",
                        borderBottom: " 1px solid #ebebeb",
                        color: "#2C65AC",
                      }}
                      key={file.file_id}
                    >
                      <div className="flex items-center">
                        <AiOutlineFolder className="mr-1 ml-1" />
                        <span
                          onClick={() =>
                            fileStore.handleDownloadFile(
                              file.file_id,
                              file.file_name
                            )
                          }
                          style={{ color: "#1890FF" }}
                        >
                          {file.file_name}
                        </span>
                      </div>
                      <AiOutlineDelete
                        className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                        onClick={() =>
                          handleRemoveFileFromDocumentList(file.file_id)
                        }
                      />
                    </li>
                  ))}
                </ul>
              )}
              {fileList.length !== 0 && (
                <ul
                  style={{
                    margin: "10px 0 0",
                    paddingLeft: "0 !important",
                    height: " auto !important",
                    overflow: "hidden !important",
                  }}
                >
                  {fileList.map((file, index) => (
                    <li
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "8px",
                        transition: "all ease 0.3s",
                        padding: "3px 0",
                        borderBottom: " 1px solid #ebebeb",
                        color: "#2C65AC",
                      }}
                      key={file.uid}
                    >
                      <div className="flex items-center">
                        <AiOutlineFolder className="mr-1 ml-1" />
                        <span style={{ color: "#1890FF" }}>{file.name}</span>
                      </div>
                      <div className="flex items-center">
                        <Button
                          className="text-[#1890FF]"
                          onClick={() => {
                            setIsRenameFileUpdate(true);
                            handleOpenPopupRenameFile(file, index);
                          }}
                        >
                          Đổi tên
                        </Button>
                        <AiOutlineDelete
                          className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                          onClick={() =>
                            handleRemoveFileFromUploadList(file.uid)
                          }
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              )}

              <Box sx={{ display: "flex", marginTop: "20px" }}>
                <InputLabel style={{ color: "#23374D" }}>
                  Người theo dõi :
                </InputLabel>
                <div>
                  <Button
                    style={{
                      color: "#ffb100",
                      marginLeft: "5px",
                      marginTop: "-5px",
                      border: "1px solid blue",
                    }}
                    onClick={() => handleOpenSelectUser(ASSIGNEE_TYPE.FOLLOWER)}
                  >
                    <AiOutlineUser />
                  </Button>
                </div>
              </Box>
              <div className="my-2">
                {followerList.length > 0 && (
                  <SelectList>
                    {followerList.map((el) => (
                      <Tag
                        className={"tag-selected"}
                        color={"blue"}
                        key={el.id}
                        closable
                        onClose={() => selectPeopleStore.handleRemoveSelect(el)}
                      >
                        <AvatarHasName
                          imgId={el.image_id}
                          size={22}
                          name={el.full_name}
                          icon={
                            (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                              <BankOutlined />
                            )) ||
                            (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                              <TeamOutlined />
                            ))
                          }
                        />
                      </Tag>
                    ))}
                  </SelectList>
                )}
              </div>
              <div className="mb-2">Tiến trình duyệt :</div>
              <div className="border border-gray rounded-sm">
                <div className="m-4 h-[400px] overflow-y-auto">
                  <Box sx={{ maxWidth: 400 }}>
                    <Stepper orientation="vertical">
                      {approvalLevels.map((step, index) => {
                        const assignTypeIndex =
                          proposalApproveConfig.approvalLevels
                            .filter((el) => el.allow_edit)
                            .findIndex((item) => item.level === step.level);
                        const handleDeleteUser = () => {
                          if ([0, 1, 2, 3].includes(assignTypeIndex)) {
                            selectPeopleStore.handleRemoveSelect({
                              assignee_type: ASSIGNEE_TYPE.USER,
                              id: step.username,
                              permission: ASSIGNEE_TYPE_CONFIG[assignTypeIndex],
                            });
                          }
                        };
                        return (
                          <Step key={step.code} expanded={true}>
                            <StepLabel
                              className="relative"
                              optional={
                                index !== 0 ? (
                                  <div className="absolute -mt-7 -ml-2 text-red-500 text-lg">
                                    *
                                  </div>
                                ) : null
                              }
                            >
                              {step.name}
                            </StepLabel>
                            <StepContent>
                              <div>
                                <div className="flex items-center">
                                  {step.username ? (
                                    step?.user ? (
                                      <SelectList>
                                        <Tag
                                          className={"tag-selected"}
                                          color={"blue"}
                                          key={step.id}
                                        >
                                          <AvatarHasName
                                            imgId={step.image_id}
                                            size={22}
                                            name={step.user.full_name}
                                          />
                                        </Tag>
                                      </SelectList>
                                    ) : (
                                      <SelectList>
                                        <Tag
                                          className={"tag-selected"}
                                          color={"blue"}
                                          key={step.id}
                                        >
                                          <AvatarHasName
                                            imgId={step.image_id}
                                            size={22}
                                            name={step.username}
                                          />
                                        </Tag>
                                      </SelectList>
                                    )
                                  ) : (
                                    <div className="border px-2 py-1 rounded-full">
                                      Chưa gán người!
                                    </div>
                                  )}
                                  {step.allow_edit === true ? (
                                    <div
                                      className="ml-2"
                                      onClick={() => {
                                        handleOpenSelectUser(step.level);
                                      }}
                                    >
                                      <div className="border p-2 rounded-lg text-[#2C65AC]">
                                        <User height={20} width={20} />
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                                <div className="my-2">
                                  <StatusTag
                                    typePage={TYPE_STATUS.PROPOSAL}
                                    status={step.status}
                                  />
                                </div>
                                {index === 0 ? (
                                  <div>
                                    {moment(step.created_at).format(
                                      "HH:mm - DD/MM/YYYY"
                                    )}
                                  </div>
                                ) : null}
                              </div>
                            </StepContent>
                          </Step>
                        );
                      })}
                    </Stepper>
                  </Box>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </DialogContent>
        <DialogActions
          sx={{
            backgroundColor: "#e3e4e9",
            position: "sticky",
            bottom: "0",
          }}
        >
          <Button
            type="button"
            onClick={close}
            className="w-[94px] h-[40px] text-sm font-bold leading-5 text-primary"
          >
            Đóng
          </Button>
          <button
            type="submit"
            className="uppercase font-bold w-[94px] h-[40px] rounded-full text-sm leading-5 text-white bg-[#0073C7]"
          >
            Tạo mới
          </button>
        </DialogActions>
      </form>
      <SelectPeoplePopup
        disableSelectDepartment
        placeholder={"Tìm theo tên người dùng"}
        onlyOneUser={checkFollower}
        handleCancelSelectUser={handleSubmitSelectUser}
        handleSubmitSelectUser={handleSubmitSelectUser}
        isVisibleSelectPeoplePopup={isVisibleSelectUserPopup}
      />
      <Message
        message={messages}
        openMessage={openMessage}
        severity={severity}
        closeMessage={() => {
          setOpenMessage(false);
        }}
      />
      <PopupRenameFile
        isModalVisibleRenameFile={isModalVisibleRenameFile}
        handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
        submitRenameFile={submitRenameFile}
        fieldsRenameFile={fieldsRenameFile}
        fileExt={fileExt}
      />
    </Dialog>
  );
};
export default inject(
  "workStore",
  "loadingAnimationStore",
  "fileStore",
  "selectPeopleStore",
  "proposalStore",
  "authenticationStore",
  "selectUserStore",
  "contentTemplateStore"
)(observer(CreateModal));
